import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./Layout/Pages/Home/index";
import Courses from "./Layout/Pages/Course/Courses";
import OffCourses from "./Layout/Pages/Course/OffCourses";
import CoursesDetail from "./Layout/Pages/Course/CoursesDetail";
import OffLineCoursesDetail from "./Layout/Pages/Course/OffLineCoursesDetail";
import CoursesDetailSubject from "./Layout/Pages/Course/CoursesDetailSubject";
import Packageplanlist from "./Layout/Pages/Course/Packageplanlist";
import CoursesDetailContent from "./Layout/Pages/Course/CoursesDetailContent";
import CoursesDetailContentVideoPdf from "./Layout/Pages/Course/CoursesDetailContentVideoPdf";
import CourseCart from "./Layout/Pages/Course/CourseCart";
import Blog from "./Layout/Pages/Blog/Blog";
import News from "./Layout/Pages/News/News";
import Books from "./Layout/Pages/Book/Books";
import Viewdetails from "./Layout/Pages/Book/Viewdetails";
import BookCart from "./Layout/Pages/Book/BookCart";
import BlogDetail from "./Layout/Pages/Blog/BlogDetail";
import NewsDetail from "./Layout/Pages/News/NewsDetail";
import Contact from "./Layout/Pages/Contact";
import AboutUs from "./Layout/Pages/AboutUs";
import Gallery from "./Layout/Pages/Gallery";
import LiveClass from "./Layout/Pages/Class/LiveClass";
import DemoClass from "./Layout/Pages/Class/DemoClass";
import Livemeeting from "./Layout/Pages/Livemeeting";
import PreviousPapers from "./Layout/Pages/PreviousPaper";
import Header from "./Layout/include/header";
import Footer from "./Layout/include/Footer";
import Privacy from "./Layout/Pages/Privacy";
import Terms from "./Layout/Pages/Terms";
import MockTestSeries from "./Layout/Pages/Test/MockTestSeries";
import SectionalTest from "./Layout/Pages/Test/SectionalTest";
import TestSeries from "./Layout/Pages/Test/TestSeries";
import ExamPage from "./Layout/Pages/Test/ExamPage";
import Dashboard from "./Layout/Pages/Dashboard";
import ExamResult from "./Layout/Pages/Test/ExamResult";
import ResultPageDemo from "./Layout/Pages/Test/ResultPageDemo";
import Demotest from "./Layout/Pages/Test/Demotest";
import Refer from "./Layout/Pages/Refer";
import NotFound from "./Layout/Pages/NotFound";
import Scholarship from "./Layout/Pages/Scholarship";
import ForgotPassword from "./Layout/Pages/ForgotPassword";
import ScrollTopButton from "./Layout/components/ScrollTopButton";
import Loader from "./Layout/components/Loader";
import ProtectedRoute from "./Layout/Pages/ProtectedRoute";
import Instructions from "./Layout/Pages/Test/Instructions";
import Instructions_mock_test from "./Layout/Pages/Test/Instructions_mock_test";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const LayoutWrapper = () => {
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();
  // const noLayoutPages  = ["/login", "/register", "/exam"];
  const noLayoutPages = ["/exam", "/Live-meeting", "/demo-exam"];
  const hideLayout = noLayoutPages.includes(pathname);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div id="main-wrapper" className="main-wrapper">
          {!hideLayout && <Header />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/offline-courses" element={<OffCourses />} />
            <Route path="/course-detail" element={<CoursesDetail />} />
            <Route
              path="/offline-course-detail"
              element={<OffLineCoursesDetail />}
            />
            <Route
              path="/course-detail-subject"
              element={<CoursesDetailSubject />}
            />
            <Route
              path="/course-detail-content"
              element={<CoursesDetailContent />}
            />
            <Route
              path="/course-detail-content-video"
              element={<CoursesDetailContentVideoPdf />}
            />
            {/* <Route path="/course-cart" element={<CourseCart />} /> */}
            <Route path="/course-cart" element={<ProtectedRoute><CourseCart /></ProtectedRoute>} />
            <Route path="/package-plan-list" element={<Packageplanlist />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/news" element={<News />} />
            <Route path="/Books" element={<Books />} />
            <Route path="/Viewdetails" element={<Viewdetails />} />
            {/* <Route path="/BookCart" element={<BookCart />} /> */}
            <Route path="/BookCart" element={<ProtectedRoute><BookCart /></ProtectedRoute>} />
            <Route path="/Live-meeting" element={<Livemeeting />} />
            <Route path="/blog-detail" element={<BlogDetail />} />
            <Route path="/news-detail" element={<NewsDetail />} />
            <Route path="/Live-class" element={<LiveClass />} />
            <Route path="/demo-class" element={<DemoClass />} />
            {/* <Route path="/Previous-Papers" element={<PreviousPapers />} />
            <Route path="/Test-Series" element={<MockTestSeries />} /> */}
            <Route path="/Previous-Papers" element={<ProtectedRoute><PreviousPapers /></ProtectedRoute>} />
            <Route path="/Test-Series" element={<ProtectedRoute><MockTestSeries /></ProtectedRoute>} />
            {/* <Route path="/sectional-test" element={<SectionalTest />} /> */}
            <Route path="/sectional-test" element={<ProtectedRoute><SectionalTest /></ProtectedRoute>} />
            {/* <Route path="/off-test-Series" element={<TestSeries />} /> */}
            <Route path="/off-test-Series" element={<ProtectedRoute><TestSeries /></ProtectedRoute>} />
            <Route path="/mock-test-exam" element={<ExamPage />} />
            {/* <Route path="/refer" element={<Refer />} /> */}
            <Route path="/refer" element={<ProtectedRoute><Refer /></ProtectedRoute>} />
            <Route path="/scholarship" element={<Scholarship />} />
            <Route path="/demo-exam" element={<Demotest />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/About-us" element={<AboutUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            {/* <Route path="/test-result" element={<ExamResult />} /> */}
            <Route path="/test-result" element={<ProtectedRoute><ExamResult /></ProtectedRoute>} />
            <Route path="/exam-result" element={<ResultPageDemo />} />
            <Route path="/model-paper-instructions" element={<Instructions />} />
            <Route path="/mock-test-instructions" element={<Instructions_mock_test />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          {!hideLayout && <Footer />}
          <ScrollTopButton />
        </div>
      )}
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <LayoutWrapper />
    </Router>
  );
}

export default App;
